import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-white position-relative overflow-auto mw-100",
  style: {"max-height":"670px"}
}
const _hoisted_2 = { class: "table table-bordered mb-6 bg-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Дата"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Пользователь (логин)"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Модуль"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Операция"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "id"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Описание"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" })
  ])
], -1)
const _hoisted_4 = { class: "py-2 px-3" }
const _hoisted_5 = { class: "py-2 px-3" }
const _hoisted_6 = { class: "py-2 px-3" }
const _hoisted_7 = { class: "py-2 px-3" }
const _hoisted_8 = { class: "py-2 px-3" }
const _hoisted_9 = { class: "py-2 px-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", {
  class: "py-5 text-center",
  colspan: "7"
}, "Логов нет", -1)
const _hoisted_13 = [
  _hoisted_12
]

import { reactive, onMounted } from 'vue';
import formatDate from '@/utils/formatDate';
import api from '@/api';
import { IUser } from '@/@types/IUser';

type auditLogType = {
    id: number;
    tableName: string;
    operation: string;
    recordId: number;
    changes: string;
    userId: number;
    author: IUser;
    createdAt: string;
};

type stateType = {
    logs: Array<auditLogType>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLogComponent',
  setup(__props) {

const state: stateType = reactive({
    logs: [],
});

function getAuditLogs() {
    return api.auditLog.get().then((res) => {
        state.logs = res.data;
    });
}

onMounted(() => {
    getAuditLogs();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (state.logs.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.logs, (log) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: log.id
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(formatDate)(log.createdAt, 'DD.MM.YYYY HH:mm')), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(log.author?.login), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(log.tableName), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(log.operation), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(log.recordId), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(log.changes), 1),
                _hoisted_10
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))
      ])
    ])
  ]))
}
}

})